import ReactLoading from "react-loading";

import "./index.scss";

const DropDownLoading = ({
  title = "درحال دریافت اطلاعات ... ",
  showTitle = true,
}: {
  title?: string;
  showTitle?: boolean;
}) => {
  return (
    <tbody id="dropdown-loading-container">
      <tr>
        <td colSpan={100}>
          <div>
            <ReactLoading
              type={"spokes"}
              color={"#21f228"}
              width={window.innerHeight / 30}
            />
          </div>{" "}
          <p>{showTitle && title}</p>
        </td>
      </tr>
    </tbody>
  );
};

export default DropDownLoading;
